// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"vx_a bhf_b bhf_wb"};